export { RegistrationModule } from "./registration.module";
